<template>
  <div id="index">
	   <div id="poster" style="width:1100px;height:276px;">
        <img :src="`${imgPath}/banner.png`" alt=""  style="width: 100%;height: 276px;">
	  </div>
    <div class="d-flex justify-between" style=" background: #f7f7f7; width: 1100px;">
      <ul id="tabs">
        <li v-for="(item,index) in tabBars" :class="{active:index===curTabIndex}"  @click='handleTab(index)'>{{item.name}}</li>
      </ul>
      <div class="search_wrap container d-flex align-center">
        <div class="search_wrap-left d-flex align-center" @click="searchClick">
            <img class="icon" :src="`${imgPath}/search.png`">
            <div class="desc">请输入你想要查找的内容</div>
          </div>
      </div>
    </div>
    <!-- 线索 -->
    <div class="listContainer">
      <!-- <div v-for="(item,index) in list">
        <h2>{{item.title}}</h2>
      </div> -->
      <template v-for="item in list">
            <List :item="item" :key="item.id" />
      </template>
        <div style="padding-top:20px;">
            <el-pagination
            background
            layout="prev, pager, next"
            :total="total"
            :current-page="pageNo"
            @current-change="handleCurrentChange"
            >
        </el-pagination>
        </div>
    </div>
    <div class="bl" @click="dialogVisible = true"></div>
    <el-dialog
    title=""
    :visible.sync="dialogVisible"
    width="500px"
    height="360px"
    :before-close="handleClose">
    </el-dialog>
  </div>
</template>

<script>
import  { imgPath } from "@/util/timer.js"
import { getChannelInfor } from "@/sdk/sdk";
import axios from "axios";
import List from "@/components/List/List.vue";
export default {
   components: {
    List
  },
  data() {
    return {
      getposterInfor:[],
      	imgPath:imgPath,
          dialogVisible: false,
       tabBars: [
        {
          index: 0,
          name: "全部",
        },
        {
          index: 1,
          name: "最热",
        },
        {
          index: 2,
          name: "已办",
        },
      ],
      curTabIndex:0,
      list:[],
      total:0,
      pageNo:1
    };
  },
  async mounted() {
    //获取海报
    // this.getPoster();
    //获取列表
    await this.getData(); 
  },
  methods: {
    searchClick(){
      this.dialogVisible=true;
    },
      handleClose(done) {
        this.dialogVisible=false;
      },
    //点击分页变化的时候
    async handleCurrentChange(val){
      this.pageNo=val;
      await this.getData(); 
    },
    //获取海报信息
    async getPoster(){
      const res_list = await getChannelInfor();
      console.log(res_list)
      if (res_list.state == 1) {
        this.getposterInfor = res_list.data;
      } else {
        // Dialog({ message: "获取信息列表失败！" + res_list.message });
      }
    },
    handleTab(id){
        this.curTabIndex=id;
        this.pageNo=1;
        if (this.curTabIndex == 0) {
        // 全部
        this.getData("newest");
      } else if (this.curTabIndex == 1) {
        // 最热
        this.getData("hottest");
      } else {
        // 已办
        this.getData("finished");
      }
    },
    async getData() {
      let item="";
      if (this.curTabIndex == 0) {
        // 全部
        item="newest"
      } else if (this.curTabIndex == 1) {
        // 最热
        item="hottest";
      } else {
        // 已办
        item="finished";
      }
      
      const config = {
            method: 'post',
            url: `https://pubmod.hntv.tv/plugins_dxrx/public/info/list/${item}`,
            data: {
              pageNo: this.pageNo,
              pageSize:10,
           }
        }
        const { data } = await axios(config);
        if (data.code === 0) {
          this.list=[];
          this.list=data.result.content;
          this.total=data.result.total;
        }
    },
  },
  computed: {
   
  },
};
</script>

<style lang="scss" scoped>
@import '../styles/index.css';
#index{width: 1200px; margin: 0px auto; position: relative; padding-bottom: 50px;}
#tabs{clear: both;overflow: hidden; margin:10px 0px; padding: 20px 0px;}
#tabs li{height: 30px;font-size: 16px; line-height: 24px; border-bottom: 0px solid #ffffff; float: left; margin:0px 9px 0px 22px; list-style: none; font-weight: bold; cursor: pointer;}
#tabs .active{ border-bottom: 2px solid #D62E2E; color:#D62E2E;}
.listContainer{width: 1100px;}
.bl{width: 52px;height: 67px; background: url('https://static.hntv.tv/total/ch/hntv2022/hotline2022/kyhzpc/images/bl.png'); position: fixed; left:50%; bottom:100px; margin-left: 530px;cursor: pointer; }
 
 .search_wrap {
		margin-top:10px;
    margin-right:22px;;
		&-left {
			width:295px;
			height: 30px;
			background: #ffffff;
			border-radius:11px;
			.icon {
				display: inline-block;
				width: 18px;
				height:18px;
				flex-shrink: 0;
				margin:0px 10px;
			}
			.desc {
				font-size:14px;
				color: #666666;
				padding-left: 12rpx;
			}
		}
	}

</style>
